import React from 'react';
import LegalLayout from '../components/layout/LegalLayout';

const TermsPage: React.FC = () => (
  <LegalLayout
    title="Terms of Service"
    subtitle="By using Jötr, you agree to these terms. Please read them carefully."
    lastUpdated="March 22, 2026"
  >
    <h2>1. Acceptance of terms</h2>
    <p>By creating an account or using Jötr, you agree to be bound by these Terms of Service and our <a href="/privacy">Privacy Policy</a>. If you do not agree, do not use Jötr.</p>

    <h2>2. Your account</h2>
    <p>You must provide accurate information when creating your account. You are responsible for maintaining the security of your account and password. Notify us immediately at <a href="mailto:support@Jötr.co">support@Jötr.co</a> if you suspect unauthorised access.</p>
    <p>You must be at least 13 years old to use Jötr. If you are under 18, you must have permission from a parent or guardian.</p>

    <h2>3. Your content</h2>
    <p>You own all content you create in Jötr — your notes, folders, and attachments. We claim no intellectual property rights over your content.</p>
    <p>By storing content with us, you grant Jötr a limited licence to store, back up, and display your content solely for the purpose of providing the service to you.</p>
    <p>You agree not to store content that:</p>
    <ul>
      <li>Is illegal, harmful, or violates any applicable law.</li>
      <li>Infringes the intellectual property rights of others.</li>
      <li>Contains malware, viruses, or other malicious code.</li>
    </ul>

    <h2>4. Acceptable use</h2>
    <p>You agree not to:</p>
    <ul>
      <li>Use Jötr to send spam or unsolicited messages.</li>
      <li>Attempt to reverse engineer, decompile, or extract the source code.</li>
      <li>Use automated tools to scrape or access the service without permission.</li>
      <li>Resell or redistribute access to Jötr without prior written consent.</li>
      <li>Impersonate Jötr or any other person or entity.</li>
    </ul>

    <h2>5. Free plan</h2>
    <p>The free plan is provided at no cost and includes the features listed on our <a href="/#pricing">pricing page</a>. We reserve the right to modify the features included in the free plan with 30 days' notice.</p>

    <h2>6. Pro plan and billing</h2>
    <p>The Pro plan is billed monthly or annually as selected at checkout. Payments are processed securely by Stripe. All fees are non-refundable except where required by law.</p>
    <p>You may cancel your Pro subscription at any time. Access continues until the end of your current billing period.</p>

    <h2>7. Availability and uptime</h2>
    <p>We aim for 99.9% uptime but do not guarantee uninterrupted access. Scheduled maintenance will be announced in advance. We are not liable for losses caused by downtime beyond our control.</p>

    <h2>8. Termination</h2>
    <p>You may delete your account at any time from the Settings page. We may suspend or terminate accounts that violate these terms, with notice where possible.</p>
    <p>On termination, your data will be permanently deleted within 30 days.</p>

    <h2>9. Limitation of liability</h2>
    <p>To the fullest extent permitted by law, Jötr is not liable for any indirect, incidental, or consequential damages arising from your use of the service. Our total liability to you shall not exceed the amount you paid us in the 12 months preceding the claim.</p>

    <h2>10. Changes to these terms</h2>
    <p>We may update these terms. We will notify you by email at least 14 days before material changes take effect. Continued use of Jötr after changes constitutes acceptance.</p>

    <h2>11. Governing law</h2>
    <p>These terms are governed by the laws of the Federal Republic of Nigeria. Any disputes shall be resolved in the courts of Lagos State.</p>

    <h2>12. Contact</h2>
    <p>Questions about these terms? Email <a href="mailto:legal@Jötr.co">legal@Jötr.co</a>.</p>
  </LegalLayout>
);

export default TermsPage;
